import React from "react";
import { useNavigate } from "react-router-dom";
import { WalletCards } from "lucide-react";
import { useAuth } from "../context/AuthContext";

// Shown above the chat composer when the workspace wallet is empty (the server refuses every billable action with 402).
export function NoCreditsBanner() {
  const { user } = useAuth();
  const nav = useNavigate();
  if (!user || Number(user.credits ?? 1) > 0) return null;
  const owner = user.role === "admin";
  return (
    <div data-testid="no-credits-banner" className="mb-2 flex flex-wrap items-center gap-3 rounded-2xl border border-[#EF4444]/30 bg-[#FEF2F2] px-4 py-2.5 text-xs">
      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#EF4444]/10 text-[#EF4444]"><WalletCards size={16} /></span>
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-slate-900">Kredit habis — isi ulang untuk melanjutkan</p>
        <p className="text-slate-600">{owner ? "Chat, panggilan, pembuatan media, dan Ruang Kerja berhenti sampai kredit diisi." : "Minta admin workspace mengisi kredit agar asisten bisa bekerja lagi."}</p>
      </div>
      {owner && <button onClick={() => nav("/wallet")} data-testid="no-credits-topup" className="btn-primary py-2 text-xs">Isi Kredit</button>}
    </div>
  );
}
